import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="shell" id="shell"></a>
    <h1 {...{
      "id": "requireuxpshell"
    }}>{`require('uxp').shell`}</h1>
    <p>{`To get an instance: `}<inlineCode parentName="p">{`require("uxp").shell`}</inlineCode><br />{`
These APIs require UXP Manifest v5 configurations. see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/photoshop/uxp/2022/guides/uxp_guide/uxp-misc/manifest-v5/#launch-process"
      }}>{`Launch Process`}</a></p>
    <a name="shell-openpath" id="shell-openpath"></a>
    <h2 {...{
      "id": "openpathpath-developertext"
    }}>{`openPath(path, developerText)`}</h2>
    <p>{`Opens the given file or folder path in the system default application.`}<br />{`
NOTE: UWP can access only files in the UWP App sandbox. See `}<a parentName="p" {...{
        "href": "https://docs.microsoft.com/en-us/windows/uwp/files/file-access-permissions"
      }}>{`File access permissions in UWP`}</a></p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<string>`}</inlineCode>{` - Promise that resolves with "" if succeeded or String containing the error message if failed.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`path`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String representing the path to open`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`developerText`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Information from the plugin developer to be displayed on the user consent dialog. Message should be localized in current host UI locale.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// for MacOS
shell.openPath("/Users/[username]/Downloads");
shell.openPath("/Users/[username]/sample.txt");

// for Windows
shell.openPath("C:\\Users\\[username]\\Downloads");
shell.openPath("C:\\Users\\[username]\\AppData\\Local\\...\\sample.txt");
`}</code></pre>
    <a name="shell-openexternal" id="shell-openexternal"></a>
    <h2 {...{
      "id": "openexternalurl-developertext"
    }}>{`openExternal(url, developerText)`}</h2>
    <p>{`Opens the url in the dedicated system applications for the scheme.`}<br />{`
NOTE: file scheme is not allowed for openExternal. Use openPath for those cases.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<string>`}</inlineCode>{` - Promise that resolves with "" if succeeded or String containing the error message if failed.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String representing the URL to open`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`developerText`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Information from the plugin developer to be displayed on the user consent dialog. Message should be localized in current host UI locale.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`shell.openExternal("https://www.adobe.com/");
shell.openExternal("https://www.adobe.com/", "develop message for the user consent dialog");
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`shell.openExternal("maps://?address=345+Park+Ave+San+Jose"); // for MacOS
shell.openExternal("bingmaps:?q=345+Park+Ave+San+Jose, +95110"); // for Windows
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      